import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState('idle');

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('loading');
    setTimeout(() => {
      setStatus('success');
      setFormData({ name: '', email: '', message: '' });
      setTimeout(() => setStatus('idle'), 3000);
    }, 1500);
  };

  return (
    <div className="max-w-5xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
        <motion.div 
          className="space-y-8"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Let's Build Together</h1>
            <p className="text-lg text-slate-400">
              I'm always open to collaborating on projects that aim to make a positive social impact or push the boundaries of accessible AI.
            </p>
          </div>

          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-emerald-500/10 text-emerald-400 flex items-center justify-center shrink-0 border border-emerald-500/20">
                <SafeIcon icon={FiIcons.FiMessageSquare} className="text-xl" />
              </div>
              <div>
                <h3 className="text-white font-medium mb-1">Collaboration</h3>
                <p className="text-slate-400">Got an idea for an underserved community? Let's talk.</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-lg bg-emerald-500/10 text-emerald-400 flex items-center justify-center shrink-0 border border-emerald-500/20">
                <SafeIcon icon={FiIcons.FiMail} className="text-xl" />
              </div>
              <div>
                <h3 className="text-white font-medium mb-1">Email</h3>
                <a href="mailto:collab@example.com" className="text-slate-400 hover:text-emerald-400 transition-colors">collab@indie-ai.dev</a>
              </div>
            </div>
          </div>

          <div className="pt-8 border-t border-slate-800">
            <h3 className="text-white font-medium mb-4">Stay Connected</h3>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-emerald-500 hover:text-slate-950 transition-all shadow-lg">
                <SafeIcon icon={FiIcons.FiGithub} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-emerald-500 hover:text-slate-950 transition-all shadow-lg">
                <SafeIcon icon={FiIcons.FiTwitter} />
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div 
          className="glass-card p-8 rounded-2xl relative"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
        >
          <form onSubmit={handleSubmit} className="space-y-6 relative z-10">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-slate-300 mb-2">Name</label>
              <input 
                type="text" 
                id="name"
                required
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="w-full bg-slate-900/50 border border-slate-700 rounded-lg px-4 py-3 text-slate-200 focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition-all"
                placeholder="Your Name"
              />
            </div>
            
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-2">Email</label>
              <input 
                type="email" 
                id="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full bg-slate-900/50 border border-slate-700 rounded-lg px-4 py-3 text-slate-200 focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition-all"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label htmlFor="message" className="block text-sm font-medium text-slate-300 mb-2">How can we work together?</label>
              <textarea 
                id="message"
                required
                rows="5"
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                className="w-full bg-slate-900/50 border border-slate-700 rounded-lg px-4 py-3 text-slate-200 focus:outline-none focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 transition-all resize-none"
                placeholder="Describe your vision or project..."
              ></textarea>
            </div>

            <button 
              type="submit" 
              disabled={status === 'loading' || status === 'success'}
              className="w-full btn-primary flex items-center justify-center gap-2 py-3"
            >
              {status === 'loading' && <SafeIcon icon={FiIcons.FiLoader} className="animate-spin" />}
              {status === 'success' && <><SafeIcon icon={FiIcons.FiCheck} /> Sent Successfully</>}
              {status === 'idle' && <><SafeIcon icon={FiIcons.FiSend} /> Send Proposal</>}
            </button>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;